import { openExternalUrl } from "../serviceUtils/urlUtil";

export const handleLinkJump = (event, that) => {
  let href;

  if (
    event.target &&
    event.target.parentNode &&
    event.target.parentNode.parentNode
  ) {
    href =
      (event.target.innerText && event.target.innerText.indexOf("http") > -1 && event.target.innerText) ||
      event.target.parentNode.href ||
      event.target.src ||
      event.target.href ||
      event.target.parentNode.parentNode.href ||
      "";
  }

  if (typeof href === 'object' && href.constructor.name === 'SVGAnimatedString') {
    href = href.baseVal;
    if (href.startsWith('blob')) {
      return;
    }
    
    // 处理内部链接
    try {
      const baseHref = href.split('#')[0]; // 移除锚点
      const spineItem = that.props.rendition.book.spine.items.find(
        item => decodeURIComponent(item.href).indexOf(baseHref) > -1
      );

      if (spineItem) {
        that.props.rendition.display(spineItem.href + (href.includes('#') ? '#' + href.split('#')[1] : ''));
      } else {
        openExternalUrl(href);
      }
    } catch (err) {
      console.log('Error handling internal link:', err);
      openExternalUrl(href);
    }
  } else if (
    href &&
    href.indexOf("../") === -1 &&
    href.indexOf("http") === 0 &&
    href.indexOf("OEBPF") === -1 &&
    href.indexOf("OEBPS") === -1 &&
    href.indexOf("footnote") === -1 &&
    href.indexOf("blob") === -1 &&
    href.indexOf("data:application") === -1 &&
    href.indexOf(".htm") === -1
  ) {
    openExternalUrl(href);
  }
  return href;
};
